export interface Article {
  id: string;
  title: string;
  slug: string;
  categorySlug: string;
  categoryName: string;
  excerpt: string;
  content: string;
  author: string;
  publishDate: string;
  readTime: number;
  imageUrl: string;
}

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '17c.com 新用户注册与登录完整教程',
    slug: 'registration-login-tutorial',
    categorySlug: 'guide',
    categoryName: '使用指南',
    excerpt: '本文将为您详细介绍 17c.com 的注册流程、登录方式以及账户安全设置，帮助您在三分钟内完成账户创建。',
    content: `<p>欢迎来到 17c.com！无论您是初次接触还是已经有所了解，本文将带您逐步完成注册与登录的全部流程。</p>
<h2>一、注册 17c.com 账户</h2>
<p>访问 17c.com 官网首页，点击右上角的"注册"按钮即可开始。您可以选择使用手机号码或电子邮箱进行注册。我们建议使用常用邮箱，以便后续找回密码。</p>
<p>填写基本信息后，系统会向您的注册邮箱发送一封验证邮件。请前往邮箱查收并点击验证链接完成账户激活。整个过程不超过三分钟。</p>
<h2>二、登录方式</h2>
<p>17c.com 支持多种登录方式：账号密码登录、短信验证码登录以及第三方社交账号快捷登录。系统会自动记住您的登录状态，方便下次访问。</p>
<p>如果您在公共设备上登录，建议勾选"隐私模式"以保护账户安全。离开时请务必退出登录。</p>
<h2>三、账户安全设置</h2>
<p>登录后，建议立即进入"账户设置"页面，完善以下安全措施：</p>
<ul>
<li>设置高强度密码（包含大小写字母、数字和特殊符号）</li>
<li>绑定备用邮箱和手机号码</li>
<li>开启登录保护（短信二次验证）</li>
<li>定期检查登录设备记录</li>
</ul>
<h2>四、常见问题</h2>
<p>如遇到注册或登录问题，您可以通过首页底部的"联系我们"渠道获取技术支持，或前往常见问题页面搜索相关解答。</p>`,
    author: '17c编辑团队',
    publishDate: '2026-07-20',
    readTime: 5,
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20modern%20clean%20digital%20interface%20showing%20a%20registration%20form%20on%20a%20laptop%20screen%20with%20a%20warm%20inviting%20background%20featuring%20soft%20ambient%20lighting%20minimalist%20design%20professional%20tech%20atmosphere%20clean%20composition%20with%20ample%20negative%20space%20editorial%20style%20high%20detail%20harmonious%20warm%20tones&width=600&height=340&seq=article-thumb-article-1&orientation=landscape',
  },
  {
    id: 'article-2',
    title: '17c.com 核心功能全面解析',
    slug: 'core-features-overview',
    categorySlug: 'features',
    categoryName: '功能介绍',
    excerpt: '深入了解 17c.com 的五大核心功能模块，包括内容浏览、个性化推荐、社区互动、数据分析和会员服务。',
    content: `<p>17c.com 作为一站式在线服务平台，集成了多项强大功能。本文将为您逐一解析每个核心模块。</p>
<h2>一、智能内容推荐</h2>
<p>基于先进的算法引擎，17c.com 能够根据您的浏览历史、兴趣偏好和行为模式，精准推荐您可能感兴趣的内容。推荐系统持续学习，越用越懂您。</p>
<h2>二、社区互动平台</h2>
<p>在 17c.com，您不仅仅是内容的消费者。通过评论、点赞、收藏和分享功能，您可以与其他用户互动交流，分享见解和经验。社区氛围友好、积极。</p>
<h2>三、数据分析仪表板</h2>
<p>对于内容创作者和企业用户，17c.com 提供详细的数据分析工具。您可以查看内容表现、用户画像、流量来源等关键指标，为内容策略提供数据支撑。</p>
<h2>四、会员专属服务</h2>
<p>17c.com 会员体系提供分层服务：基础会员免费使用核心功能，高级会员享受去广告、优先客服、专属内容和更多存储空间等特权。</p>
<h2>五、跨平台同步</h2>
<p>无论您使用电脑、平板还是手机，17c.com 都能提供一致的使用体验。所有数据实时同步，随时随地访问您的内容。</p>`,
    author: '17c编辑团队',
    publishDate: '2026-07-18',
    readTime: 8,
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20sleek%20digital%20dashboard%20with%20multiple%20data%20visualization%20panels%20floating%20in%20a%20warm%20modern%20interface%20soft%20amber%20and%20gold%20accent%20colors%20clean%20minimalist%20design%20professional%20tech%20atmosphere%20editorial%20product%20photography%20with%20soft%20lighting%20harmonious%20warm%20color%20palette&width=600&height=340&seq=article-thumb-article-2&orientation=landscape',
  },
  {
    id: 'article-3',
    title: '17c.com 隐私保护与数据安全白皮书',
    slug: 'privacy-security-whitepaper',
    categorySlug: 'security',
    categoryName: '安全与隐私',
    excerpt: '全面了解 17c.com 在用户隐私保护和数据安全方面采取的多层防护措施，以及我们对用户数据的郑重承诺。',
    content: `<p>在 17c.com，我们深知用户隐私和数据安全的重要性。本白皮书将详细阐述我们的安全体系。</p>
<h2>一、数据加密传输</h2>
<p>所有与 17c.com 的数据传输均采用 TLS 1.3 加密协议，确保数据在传输过程中不被窃取或篡改。我们使用行业最高标准的加密算法保护您的信息安全。</p>
<h2>二、多层访问控制</h2>
<p>17c.com 实施严格的访问控制策略：网络层防火墙、应用层认证、数据层权限管理，三层防护确保只有授权人员才能访问敏感数据。</p>
<h2>三、隐私政策透明</h2>
<p>我们承诺：绝不将用户数据出售给第三方；仅在法律要求或用户明确授权的情况下共享数据；用户随时可以导出或删除自己的全部数据。</p>
<h2>四、定期安全审计</h2>
<p>17c.com 每季度接受独立第三方安全机构的全方位渗透测试和代码审计，确保安全防线始终处于最佳状态。</p>
<h2>五、用户自我保护建议</h2>
<p>我们建议用户：定期更换密码、开启双因素认证、谨慎对待钓鱼邮件、不在公共网络下登录敏感账户。</p>`,
    author: '17c安全团队',
    publishDate: '2026-07-15',
    readTime: 7,
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20modern%20cybersecurity%20concept%20with%20a%20glowing%20shield%20icon%20over%20a%20digital%20network%20grid%20warm%20amber%20and%20deep%20navy%20tones%20abstract%20technology%20pattern%20background%20professional%20and%20trustworthy%20atmosphere%20clean%20minimalist%20composition%20editorial%20photography%20style%20with%20soft%20lighting&width=600&height=340&seq=article-thumb-article-3&orientation=landscape',
  },
  {
    id: 'article-4',
    title: '17c.com 移动端使用技巧大全',
    slug: 'mobile-tips-collection',
    categorySlug: 'guide',
    categoryName: '使用指南',
    excerpt: '汇总 17c.com 移动端的实用技巧和隐藏功能，让您在手机上也能高效使用平台的全部功能。',
    content: `<p>越来越多的用户选择在移动设备上使用 17c.com。本文整理了移动端的实用技巧，帮助您提升使用效率。</p>
<h2>一、快捷手势操作</h2>
<p>左滑返回上一页、双击顶部快速回到页面顶端、长按文章卡片预览内容摘要——这些手势操作能显著提升您的浏览效率。</p>
<h2>二、离线阅读模式</h2>
<p>在 Wi-Fi 环境下，17c.com 会自动缓存您感兴趣的内容。即使在没有网络的情况下，您也可以继续阅读已缓存的文章。</p>
<h2>三、通知个性化设置</h2>
<p>进入设置页面，您可以精细控制推送通知：选择接收哪些类型的内容更新、设置免打扰时段、调整通知频率。</p>
<h2>四、深色模式适配</h2>
<p>17c.com 全面支持深色模式，在夜间或低光环境下保护您的视力。系统会根据您的设备设置自动切换，也可手动调整。</p>
<h2>五、快速分享功能</h2>
<p>长按任意内容卡片，即可快速分享到微信、QQ 等社交平台。分享链接会自动带上您的推荐标识。</p>`,
    author: '17c编辑团队',
    publishDate: '2026-07-12',
    readTime: 6,
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20smartphone%20held%20in%20hand%20displaying%20a%20clean%20modern%20app%20interface%20with%20warm%20amber%20accents%20soft%20natural%20lighting%20on%20a%20wooden%20desk%20lifestyle%20product%20photography%20minimalist%20composition%20harmonious%20warm%20tones%20editorial%20quality%20cozy%20atmosphere%20with%20a%20plant%20in%20background&width=600&height=340&seq=article-thumb-article-4&orientation=landscape',
  },
  {
    id: 'article-5',
    title: '17c.com v3.0 版本更新亮点速览',
    slug: 'v3-update-highlights',
    categorySlug: 'changelog',
    categoryName: '更新日志',
    excerpt: '17c.com 迎来重大版本更新，全新界面设计、性能大幅提升、新增智能搜索等多项功能优化。',
    content: `<p>17c.com v3.0 版本正式上线！本次更新涵盖界面重构、性能优化和多项新功能。让我们一起来看看有哪些亮点。</p>
<h2>一、全新界面设计</h2>
<p>我们重新设计了整个平台的用户界面，采用更加简洁、现代的视觉风格。新的设计语言强调内容的可读性和操作的直观性，降低了新用户的学习成本。</p>
<h2>二、性能大幅提升</h2>
<p>页面加载速度提升 40%，搜索响应时间缩短至 200 毫秒以内，图片加载采用渐进式渲染技术，即使在网络较慢的情况下也能获得流畅体验。</p>
<h2>三、智能全局搜索</h2>
<p>全新升级的搜索引擎支持模糊匹配、同义词识别和拼音搜索。您可以用自然语言描述需求，系统会智能理解并返回最相关的结果。</p>
<h2>四、个性化首页</h2>
<p>首页现在支持模块化定制：您可以自由调整各模块的显示顺序，选择感兴趣的内容类型，打造专属的信息流。</p>
<h2>五、其他优化</h2>
<p>还包括：深色模式全面优化、无障碍访问改进、通知中心重构、离线缓存策略升级等数十项细节改进。</p>`,
    author: '17c产品团队',
    publishDate: '2026-07-08',
    readTime: 6,
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20futuristic%20digital%20interface%20design%20concept%20with%20flowing%20data%20visualization%20elements%20warm%20amber%20and%20gold%20accents%20on%20a%20dark%20sophisticated%20background%20modern%20tech%20aesthetic%20clean%20geometric%20patterns%20editorial%20quality%20soft%20ambient%20glow%20harmonious%20composition&width=600&height=340&seq=article-thumb-article-5&orientation=landscape',
  },
  {
    id: 'article-6',
    title: '17c.com 会员权益与定价说明',
    slug: 'membership-benefits-pricing',
    categorySlug: 'features',
    categoryName: '功能介绍',
    excerpt: '完整介绍 17c.com 免费版和高级会员的各项权益区别，帮助您选择最适合的方案。',
    content: `<p>17c.com 提供免费版和高级会员两种服务方案。本文将详细对比两者的权益差异，帮助您做出明智选择。</p>
<h2>一、免费版权益</h2>
<p>免费注册即可享受：每日浏览 50 篇文章、基础搜索功能、社区评论互动、标准客服支持、5GB 云存储空间。对于普通用户而言，免费版已经能覆盖大部分日常需求。</p>
<h2>二、高级会员权益</h2>
<p>高级会员年费仅需 ¥198，即可解锁：无限制浏览、AI 智能推荐增强、去广告体验、优先客服响应（30 分钟内）、50GB 云存储、专属内容抢先看、离线下载、数据分析面板。</p>
<h2>三、方案对比</h2>
<p>如果您是轻度用户，免费版完全足够。如果您是重度用户、内容创作者或企业用户，高级会员的投资回报率极高。平均每天不到 0.6 元即可享受全部高级功能。</p>
<h2>四、如何升级</h2>
<p>登录后进入"我的账户"页面，点击"升级会员"即可。支持微信支付、支付宝等多种支付方式，支付成功后权益立即生效。</p>`,
    author: '17c运营团队',
    publishDate: '2026-07-05',
    readTime: 5,
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20premium%20membership%20card%20concept%20with%20warm%20golden%20metallic%20finish%20on%20a%20clean%20desk%20surface%20soft%20natural%20lighting%20elegant%20minimal%20design%20professional%20product%20photography%20harmonious%20warm%20tones%20lifestyle%20aesthetic%20with%20a%20subtle%20plant%20accent&width=600&height=340&seq=article-thumb-article-6&orientation=landscape',
  },
  {
    id: 'article-7',
    title: '如何解决 17c.com 加载缓慢的问题',
    slug: 'fix-slow-loading',
    categorySlug: 'faq-articles',
    categoryName: '常见问题',
    excerpt: '当您在使用 17c.com 时遇到加载缓慢的情况，可以参考本文提供的排查步骤和解决方案。',
    content: `<p>如果您在使用 17c.com 过程中遇到加载缓慢的问题，请不要着急。以下是系统性的排查和解决方法。</p>
<h2>一、检查网络连接</h2>
<p>首先确认您的网络连接正常。可以尝试访问其他网站测试网络速度。如果使用 Wi-Fi，尝试靠近路由器或切换到移动数据网络。</p>
<h2>二、清除浏览器缓存</h2>
<p>浏览器缓存积累过多可能导致页面加载缓慢。进入浏览器设置，清除缓存和 Cookie，然后重新访问 17c.com。</p>
<h2>三、更新浏览器版本</h2>
<p>确保您使用的是最新版本的浏览器。17c.com 针对 Chrome、Edge、Safari 和 Firefox 的最新版本进行了优化。</p>
<h2>四、关闭浏览器扩展</h2>
<p>部分广告拦截器或脚本扩展可能影响 17c.com 的正常加载。尝试在隐身模式下访问，或暂时禁用扩展程序。</p>
<h2>五、联系技术支持</h2>
<p>如果以上方法均未能解决问题，请通过"关于我们"页面的联系方式与技术支持团队取得联系，我们将尽快为您排查。</p>`,
    author: '17c技术支持',
    publishDate: '2026-07-02',
    readTime: 4,
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20modern%20tech%20support%20concept%20with%20a%20laptop%20displaying%20diagnostic%20interface%20warm%20amber%20notification%20icons%20clean%20desk%20setup%20soft%20natural%20lighting%20professional%20atmosphere%20minimalist%20composition%20harmonious%20warm%20tones%20editorial%20photography&width=600&height=340&seq=article-thumb-article-7&orientation=landscape',
  },
  {
    id: 'article-8',
    title: '用户故事：从零开始用 17c.com 搭建内容体系',
    slug: 'user-story-content-system',
    categorySlug: 'stories',
    categoryName: '用户故事',
    excerpt: '独立创作者李明分享他如何借助 17c.com 从零开始构建个人内容体系，并在六个月内积累上万粉丝的真实经历。',
    content: `<p>今天我们有幸邀请到 17c.com 的资深用户李明，分享他使用平台的心路历程。</p>
<h2>一、起步阶段</h2>
<p>"半年前，我还是一个对内容创作一无所知的新手。"李明回忆道，"通过 17c.com 的使用指南，我迅速掌握了平台的基本操作。分类清晰的内容结构让我能够系统性地学习相关知识。"</p>
<h2>二、内容规划</h2>
<p>李明利用 17c.com 的数据分析功能，发现了几个高需求但供给不足的内容方向。他据此制定了详细的创作计划，每周固定产出两篇深度文章。</p>
<h2>三、粉丝增长</h2>
<p>"坚持三个月后，我的文章开始出现在 17c.com 的首页推荐位，单日阅读量从两位数跃升至四位数。到第六个月，累计关注者突破了一万。"</p>
<h2>四、经验总结</h2>
<p>李明认为成功的关键在于：持续输出高质量内容、积极与读者互动、善用平台的数据工具优化策略。"17c.com 不仅仅是内容平台，更是创作者成长的加速器。"</p>`,
    author: '17c编辑团队',
    publishDate: '2026-06-28',
    readTime: 6,
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20creative%20workspace%20with%20a%20focused%20person%20working%20on%20a%20laptop%20warm%20amber%20desk%20lamp%20lighting%20modern%20minimalist%20office%20setup%20inspirational%20atmosphere%20lifestyle%20photography%20soft%20natural%20window%20light%20harmonious%20warm%20tones%20editorial%20quality&width=600&height=340&seq=article-thumb-article-8&orientation=landscape',
  },
  {
    id: 'article-9',
    title: '17c.com 账户异常登录处理指南',
    slug: 'account-security-alert',
    categorySlug: 'security',
    categoryName: '安全与隐私',
    excerpt: '如果您的 17c.com 账户出现异常登录提示，请立即按照本指南的步骤保护您的账户安全。',
    content: `<p>账户安全是 17c.com 的头等大事。如果您收到异常登录提醒，请立即采取以下措施。</p>
<h2>一、立即修改密码</h2>
<p>第一步，使用您还记得的安全设备登录 17c.com，进入账户设置立即修改密码。新密码应该与旧密码完全不同，且包含大小写字母、数字和特殊符号。</p>
<h2>二、检查登录设备</h2>
<p>在"安全设置"中查看最近的登录记录。如果发现不认识的设备或地点，点击"强制下线"将其踢出。</p>
<h2>三、开启双重验证</h2>
<p>如果您尚未开启双重验证，现在是最佳时机。绑定手机号码后，每次新设备登录都需要输入短信验证码。</p>
<h2>四、检查关联账户</h2>
<p>确认您的邮箱和手机号码未被篡改。如有异常，立即修正并联系客服。</p>
<h2>五、联系安全团队</h2>
<p>如果发现账户已被他人操作，请立即联系 17c.com 安全团队：security@17c.com。我们将协助您恢复账户控制权。</p>`,
    author: '17c安全团队',
    publishDate: '2026-06-25',
    readTime: 5,
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20cybersecurity%20alert%20concept%20with%20a%20glowing%20warning%20indicator%20on%20a%20dark%20digital%20interface%20warm%20amber%20alert%20lights%20modern%20tech%20aesthetic%20professional%20security%20atmosphere%20clean%20composition%20soft%20ambient%20glow%20editorial%20quality&width=600&height=340&seq=article-thumb-article-9&orientation=landscape',
  },
  {
    id: 'article-10',
    title: '17c.com 社区规范与行为准则',
    slug: 'community-guidelines',
    categorySlug: 'guide',
    categoryName: '使用指南',
    excerpt: '了解 17c.com 社区的基本规范和用户行为准则，共同维护积极健康的社区环境。',
    content: `<p>17c.com 致力于打造一个友善、包容、有价值的内容社区。请所有用户在参与互动时遵守以下规范。</p>
<h2>一、基本原则</h2>
<p>尊重他人、诚实守信、遵守法律——这是 17c.com 社区的三条底线。任何违反这些原则的行为都将受到处理。</p>
<h2>二、内容规范</h2>
<p>发布的评论和内容不得包含：人身攻击、仇恨言论、虚假信息、垃圾广告、侵犯他人知识产权的内容。我们鼓励建设性的讨论和理性的观点交流。</p>
<h2>三、举报机制</h2>
<p>如果您发现违规内容，可以使用每条内容右下角的"举报"按钮。我们的审核团队会在 24 小时内处理所有举报。</p>
<h2>四、违规处理</h2>
<p>首次轻微违规将收到警告通知；多次违规可能导致内容被隐藏、评论功能受限；严重或屡次违规将导致账户被暂停或永久封禁。</p>
<h2>五、申诉渠道</h2>
<p>如果您认为处理决定有误，可以通过"关于我们"页面的联系方式提交申诉。我们会在 3 个工作日内复核并回复。</p>`,
    author: '17c编辑团队',
    publishDate: '2026-06-20',
    readTime: 5,
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20harmonious%20community%20concept%20illustration%20showing%20diverse%20people%20icons%20connected%20in%20a%20warm%20network%20soft%20amber%20and%20gold%20tones%20modern%20flat%20design%20style%20clean%20composition%20professional%20atmosphere%20editorial%20quality%20warm%20and%20inviting%20feel&width=600&height=340&seq=article-thumb-article-10&orientation=landscape',
  },
];